import { useState, useEffect } from 'react';
import { Timer } from '../Timer';

const useTimerFinished = (timer: Timer): { finished: boolean; offsetFinished: boolean } => {
    const [finished, setFinished] = useState<boolean>(timer.finished);
    const [offsetFinished, setOffsetFinished] = useState<boolean>(timer.finishedWithOffset);

    useEffect(
        () =>
            timer.subscribe({
                onFinish: () => {
                    setFinished(true);
                },
                onFinishWithOffset: () => {
                    setOffsetFinished(true);
                },
                onUpdate: () => {
                    setFinished(false);
                    setOffsetFinished(false);
                },
            }),
        [],
    );

    return { finished, offsetFinished };
};

export default useTimerFinished;
